(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huhuli-category-circles"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__HuhuliCatCirclesInit) return;
  window.__HuhuliCatCirclesInit = true;

  function init(root){
    if (!root || root.__hscInit) return;
    root.__hscInit = true;

    var scroller = root.querySelector('[data-hsc-scroller]');
    var track = root.querySelector('[data-hsc-track]');
    if (!scroller || !track) return;

    // Fareyle basılı tutup sürükleyerek kaydırma (dokunmatik native scroll ile çalışır)
    var drag = null;
    var DRAG_THRESHOLD = 5;
    var suppressClick = false;

    track.addEventListener('dragstart', function(e){ e.preventDefault(); });

    scroller.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { startX: e.clientX, startScroll: scroller.scrollLeft, moved: false };
      scroller.classList.add('is-grabbing');
    });

    window.addEventListener('pointermove', function(e){
      if (!drag) return;
      var dx = e.clientX - drag.startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) drag.moved = true;
      scroller.scrollLeft = drag.startScroll - dx;
    });

    function endDrag(){
      if (!drag) return;
      if (drag.moved) suppressClick = true;
      drag = null;
      scroller.classList.remove('is-grabbing');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Sürükleme sonrası link tıklamasını engelle
    scroller.addEventListener('click', function(e){
      if (suppressClick){
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);
  }

  function initAll(){
    document.querySelectorAll('[data-huhuli-cat-circles]').forEach(init);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-huhuli-cat-circles]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huhuli-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__HuhuliSliderInit) return;
  window.__HuhuliSliderInit = true;

  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    if (!root || root.__hslInit) return;
    root.__hslInit = true;

    var viewport = root.querySelector('[data-hsl-viewport]');
    var track    = root.querySelector('[data-hsl-track]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hsl-slide]'));
    if (slides.length === 0) return;

    var prevBtn  = root.querySelector('[data-hsl-prev]');
    var nextBtn  = root.querySelector('[data-hsl-next]');
    var dots     = Array.prototype.slice.call(root.querySelectorAll('[data-hsl-dot]'));
    var progress = root.querySelector('[data-hsl-progress]');
    var live     = root.querySelector('[data-hsl-live]');

    var autoplay   = root.getAttribute('data-autoplay') === '1' && !prefersReduce;
    var autoSpeed  = Math.max(2, parseFloat(root.getAttribute('data-autoplay-speed') || '6')) * 1000;
    var loop       = root.getAttribute('data-loop') === '1';
    var pauseHover = root.classList.contains('is-pause-hover');

    var current     = 0;
    var autoTimer   = null;
    var progressRAF = null;
    var progressStart = 0;
    var isPaused    = false;
    var isHovering  = false;
    var isFocused   = false;

    function goTo(index, opts){
      opts = opts || {};
      var len = slides.length;
      var prevIndex = current;
      if (loop){
        index = (index + len) % len;
      } else {
        index = Math.max(0, Math.min(len - 1, index));
      }
      // Komşu (1 adım) geçişler smooth animasyonla; çok-adımlı atlamalar ve
      // loop wrap (son↔ilk) anlık snap. scroll-snap-stop:always smooth bir
      // kaydırmayı aradaki ilk snap noktasında durdurur, bu yüzden 1'den uzak
      // her atlama anlık olmalı — yoksa loop başa dönmez, bir slide geri takılır.
      var dist = Math.abs(index - prevIndex);
      var useInstant = opts.instant || dist > 1;

      current = index;
      var target = slides[current];
      if (!target) return;

      viewport.__hslSnap = true;
      // Programatik scroll bitene kadar nearest detection'ı kilitle (smooth scroll ~400-600ms sürer)
      clearTimeout(viewport.__hslSnapT);
      viewport.__hslSnapT = setTimeout(function(){ viewport.__hslSnap = false; }, useInstant ? 80 : 700);

      if (useInstant){
        // behavior:'auto' CSS scroll-behavior:smooth'a teslim olur → anlık DEĞİL.
        // Smooth'u geçici kapatıp scrollLeft'i direkt set ederek sert snap zorla.
        var prevBeh = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target.offsetLeft;
        track.style.scrollBehavior = prevBeh;
      } else {
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }

      updateActiveState();
      updateNav();
      announce();
      resetProgress();
    }

    function updateActiveState(){
      dots.forEach(function(d, i){
        var active = i === current;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateNav(){
      if (!prevBtn || !nextBtn) return;
      if (loop){
        prevBtn.removeAttribute('aria-disabled');
        nextBtn.removeAttribute('aria-disabled');
        return;
      }
      if (current <= 0) prevBtn.setAttribute('aria-disabled', 'true');
      else prevBtn.removeAttribute('aria-disabled');
      if (current >= slides.length - 1) nextBtn.setAttribute('aria-disabled', 'true');
      else nextBtn.removeAttribute('aria-disabled');
    }

    function announce(){
      if (!live) return;
      live.textContent = 'Slide ' + (current + 1) + ' / ' + slides.length;
    }

    function next(){ goTo(current + 1); }
    function prev(){ goTo(current - 1); }

    var scrollRAF = null;
    track.addEventListener('scroll', function(){
      // __hslSnap timeout goTo'da set edildi; burada sıfırlama, yoksa programatik scroll bitiminden önce nearest detection devreye girer (loop wrap bug'ı)
      if (scrollRAF) cancelAnimationFrame(scrollRAF);
      scrollRAF = requestAnimationFrame(function(){
        if (viewport.__hslSnap) return;
        var center = track.scrollLeft + track.clientWidth / 2;
        var nearest = 0;
        var nearestDist = Infinity;
        for (var i = 0; i < slides.length; i++){
          var s = slides[i];
          var mid = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < nearestDist){ nearestDist = d; nearest = i; }
        }
        if (nearest !== current){
          current = nearest;
          updateActiveState();
          updateNav();
          announce();
          resetProgress();
        }
      });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); prev(); userInteracted(); });
    if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); next(); userInteracted(); });
    dots.forEach(function(d){
      d.addEventListener('click', function(e){
        e.preventDefault();
        var idx = parseInt(d.getAttribute('data-index'), 10) || 0;
        goTo(idx);
        userInteracted();
      });
    });

    viewport.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight'){ e.preventDefault(); next(); userInteracted(); }
      else if (e.key === 'ArrowLeft'){ e.preventDefault(); prev(); userInteracted(); }
      else if (e.key === 'Home'){ e.preventDefault(); goTo(0); userInteracted(); }
      else if (e.key === 'End'){ e.preventDefault(); goTo(slides.length - 1); userInteracted(); }
    });

    // Fare ile basılı tutup sürükleyerek geçiş (dokunmatik/trackpad zaten native scroll ile çalışır)
    if (slides.length > 1){
      viewport.style.cursor = 'grab';
      var drag = null;
      var dragSuppressClick = false;
      var DRAG_THRESHOLD = 5; // px — bu eşiğin altı tıklama sayılır (link açılır)

      // Görselin native "hayalet sürükleme"sini kapat
      track.addEventListener('dragstart', function(e){ e.preventDefault(); });

      viewport.addEventListener('pointerdown', function(e){
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        // Ok/nokta üzerinde sürükleme başlatma
        if (e.target.closest('.hsl__nav, [data-hsl-dot]')) return;
        drag = {
          startX: e.clientX,
          startScroll: track.scrollLeft,
          moved: false,
          prevBeh: track.style.scrollBehavior,
          prevSnap: track.style.scrollSnapType
        };
        // Sürükleme süresince smooth + snap kapat → imleci birebir takip etsin
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        viewport.style.cursor = 'grabbing';
        document.body.style.userSelect = 'none';
        viewport.__hslSnap = true; // scroll listener nearest detection'ı drag boyunca kilitle
        pauseAuto();
      });

      window.addEventListener('pointermove', function(e){
        if (!drag) return;
        var dx = e.clientX - drag.startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) drag.moved = true;
        track.scrollLeft = drag.startScroll - dx;
      });

      function endDrag(){
        if (!drag) return;
        var moved = drag.moved;
        track.style.scrollBehavior = drag.prevBeh;
        track.style.scrollSnapType = drag.prevSnap;
        viewport.style.cursor = 'grab';
        document.body.style.userSelect = '';
        viewport.__hslSnap = false;
        drag = null;
        if (moved){
          dragSuppressClick = true; // sürükleme sonrası link tıklamasını engelle
          // En yakın slide'a snap (goTo komşuysa smooth, uzaksa anlık)
          var center = track.scrollLeft + track.clientWidth / 2;
          var nearest = 0, best = Infinity;
          for (var i = 0; i < slides.length; i++){
            var mid = slides[i].offsetLeft + slides[i].offsetWidth / 2;
            var d = Math.abs(mid - center);
            if (d < best){ best = d; nearest = i; }
          }
          goTo(nearest);
          userInteracted();
        } else {
          resumeAuto();
        }
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      // Sürüklemeden sonra gelen click slide linkini açmasın (capture fazında yakala)
      viewport.addEventListener('click', function(e){
        if (dragSuppressClick){
          e.preventDefault();
          e.stopPropagation();
          dragSuppressClick = false;
        }
      }, true);
    }

    // Mobil dokunmatik döngü: native scroll uçlarda durur, son slide'da ileri /
    // ilk slide'da geri parmakla kaydırınca wrap olmaz. Uca değdikten SONRAki
    // fazladan çekişi (overdrag) ölçüp eşiği geçince wrap tetikle. Normal
    // (uç-olmayan) kaydırma native momentum ile aynen çalışmaya devam eder.
    if (loop && slides.length > 1){
      var tActive = false;
      var tEdgeX = null;    // parmak X'i — uca İLK değdiği an (overdrag bu noktadan ölçülür)
      var tOver = 0;        // uçtaki fazladan çekiş (px); + = sağa (geri), − = sola (ileri)
      var EDGE_TOL = 2;     // px — uç toleransı
      var WRAP_TH = 55;     // px — wrap için gereken overdrag

      track.addEventListener('touchstart', function(e){
        if (e.touches.length !== 1){ tActive = false; return; }
        tActive = true; tEdgeX = null; tOver = 0;
      }, { passive: true });

      track.addEventListener('touchmove', function(e){
        if (!tActive || e.touches.length !== 1) return;
        var x = e.touches[0].clientX;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var atLeft  = track.scrollLeft <= EDGE_TOL;
        var atRight = track.scrollLeft >= maxScroll - EDGE_TOL;
        if (atLeft || atRight){
          if (tEdgeX === null) tEdgeX = x;   // uca yeni değdi → referans al
          tOver = x - tEdgeX;
          // Yön kilidi: sol uçta sadece sağa çekiş (geri), sağ uçta sadece sola (ileri) sayılır
          if (atLeft  && tOver < 0) tOver = 0;
          if (atRight && tOver > 0) tOver = 0;
        } else {
          tEdgeX = null; tOver = 0;          // uçtan ayrıldı → sıfırla
        }
      }, { passive: true });

      function endTouch(){
        if (!tActive) return;
        tActive = false;
        if (tOver > WRAP_TH){ goTo(current - 1); userInteracted(); }       // ilk slide'da geri → son'a
        else if (tOver < -WRAP_TH){ goTo(current + 1); userInteracted(); } // son slide'da ileri → ilk'e
        tEdgeX = null; tOver = 0;
      }
      track.addEventListener('touchend', endTouch, { passive: true });
      track.addEventListener('touchcancel', endTouch, { passive: true });
    }

    if (pauseHover){
      root.addEventListener('mouseenter', function(){ isHovering = true; pauseAuto(); });
      root.addEventListener('mouseleave', function(){ isHovering = false; resumeAuto(); });
    }
    root.addEventListener('focusin', function(){ isFocused = true; pauseAuto(); });
    root.addEventListener('focusout', function(e){
      if (!root.contains(e.relatedTarget)){ isFocused = false; resumeAuto(); }
    });

    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) resumeAuto();
          else pauseAuto();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    }

    document.addEventListener('visibilitychange', function(){
      if (document.hidden) pauseAuto();
      else resumeAuto();
    });

    function userInteracted(){
      pauseAuto();
      clearTimeout(root.__hslResume);
      root.__hslResume = setTimeout(resumeAuto, 4000);
    }

    function pauseAuto(){ isPaused = true; clearTimer(); cancelProgress(); }
    function resumeAuto(){
      if (isHovering || isFocused || document.hidden) return;
      isPaused = false;
      startTimer();
      startProgress();
    }

    function clearTimer(){ if (autoTimer){ clearTimeout(autoTimer); autoTimer = null; } }

    function startTimer(){
      if (!autoplay || slides.length < 2 || isPaused) return;
      clearTimer();
      autoTimer = setTimeout(function(){
        if (!loop && current >= slides.length - 1){ goTo(0); }
        else { next(); }
        // Recursive restart — autoplay sürekliliği için. goTo() resetProgress çağırır ama timer'ı restart etmez
        startTimer();
      }, autoSpeed);
    }

    function resetProgress(){
      cancelProgress();
      if (autoplay && !isPaused) startProgress();
      else if (progress) progress.style.width = '0%';
    }

    function cancelProgress(){
      if (progressRAF){ cancelAnimationFrame(progressRAF); progressRAF = null; }
    }

    function startProgress(){
      if (!progress || !autoplay || slides.length < 2 || isPaused) return;
      progress.style.width = '0%';
      progressStart = performance.now();
      function tick(now){
        if (isPaused){ return; }
        var pct = Math.min(1, (now - progressStart) / autoSpeed);
        progress.style.width = (pct * 100).toFixed(2) + '%';
        if (pct < 1) progressRAF = requestAnimationFrame(tick);
      }
      progressRAF = requestAnimationFrame(tick);
    }

    updateNav();
    if (autoplay){ startTimer(); startProgress(); }

    var resizeRAF = null;
    window.addEventListener('resize', function(){
      if (resizeRAF) cancelAnimationFrame(resizeRAF);
      resizeRAF = requestAnimationFrame(function(){
        goTo(current, { instant: true });
      });
    });
  }

  function initAll(){
    document.querySelectorAll('[data-huhuli-slider]').forEach(init);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-huhuli-slider]');
    if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
